import { render, staticRenderFns } from "./notification-popover.vue?vue&type=template&id=5c11be34&scoped=true"
import script from "./notification-popover.vue?vue&type=script&lang=js"
export * from "./notification-popover.vue?vue&type=script&lang=js"
import style0 from "./notification-popover.vue?vue&type=style&index=0&id=5c11be34&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c11be34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c11be34')) {
      api.createRecord('5c11be34', component.options)
    } else {
      api.reload('5c11be34', component.options)
    }
    module.hot.accept("./notification-popover.vue?vue&type=template&id=5c11be34&scoped=true", function () {
      api.rerender('5c11be34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/notification-popover.vue"
export default component.exports